/* eslint-disable no-undef */

jQuery( function( $ ) {
	$( window ).on( 'load', function() {
		$( '.ar.close' ).on( 'click', function() {
			$( '.ar.overlay' ).hide();
		} );

		const setupQrCodeClick = () => {
			$( '.generate-qr-code' ).on( 'click', function() {
				const hrefArray = $( this ).attr( 'href' ).split( '?' );

				openAR( hrefArray[ 1 ] );

				return false;
			} );
		};
		setupQrCodeClick();

		// Re-initialize the QR Code Generator when the results are updated (on search results page or on Filters pages)
		wp.hooks.addAction( 'qalaElasticCore.action.onResult.results', 'ankarsrumQrCodeGenerator', () => {
			// Doing this with timeout to be sure that the results are updated before we try to re-initialize the QR Code Generator.
			// They most likely would be updated without the timeout, but this is just to be sure.
			setTimeout( () => {
				setupQrCodeClick();
			}, 100 );
		} );

		function openAR( arComponent ) {
			$( '.ar.overlay' ).show();

			const href = 'https://' + window.location.hostname + '/wp-content/themes/ankarsrum/ac-templates/ar-files/' + arComponent; // So that both iOS devices and Android devices can get the URL

			if ( isMobile.iOS() ) { //Preparation so that we can have a separate for Android also
				$( '.ar.text.withcode' ).hide();
				$( '.ar.text.withmodelviewer.box.android' ).hide();
				$( '.ar.text.withmodelviewer.box.iOS' ).show();

				const modelvieweriOS = '<model-viewer poster="' + href + '.jpg" ios-src="' + href + '.usdz" ar="" auto-rotate="" camera-controls="" disable-zoom="" data-js-focus-visible="" exposure="1.5" camera-orbit="40deg 80deg" ar-status="not-presenting"></model-viewer>';

				$( '.ar.modelviewer' ).html( modelvieweriOS );

				return false;
			} else if ( isMobile.Android() ) { //Preparation so that we can have a separate for Android also
				$( '.ar.text.withcode' ).hide();
				$( '.ar.text.withmodelviewer.box.iOS' ).hide();
				$( '.ar.text.withmodelviewer.box.android' ).show();

				const modelviewerAndroid = '<model-viewer poster="' + href + '.jpg" src="' + href + '.glb" ar="" auto-rotate="" camera-controls="" disable-zoom="" data-js-focus-visible="" exposure="1.5" camera-orbit="40deg 80deg" ar-status="not-presenting"></model-viewer>';

				$( '.ar.modelviewer' ).html( modelviewerAndroid );

				return false;
			}
			$( '.ar.text.withcode' ).show();
			$( '.ar.text.withmodelviewer.box.iOS' ).hide();
			$( '.ar.text.withmodelviewer.box.android' ).hide();

			const hrefQR = window.location.href.split( '?' )[ 0 ] + '?openAR?' + arComponent;

			const qrsize = 128;

			// Clear Previous QR Code
			$( '#qrcode' ).empty();

			// Set Size to Match User Input
			$( '#qrcode' ).css( {
				width: qrsize,
				height: qrsize,
				'margin-left': '20px',
			} );

			// Generate and Output QR Code
			$( '#qrcode' ).qrcode( { width: qrsize, height: qrsize, text: hrefQR } );

			return false;
		}

		const isMobile = {
			Android() {
				return navigator.userAgent.match( /Android/i );
			},
			BlackBerry() {
				return navigator.userAgent.match( /BlackBerry/i );
			},
			iPhone() {
				return navigator.userAgent.match( /iPhone/i );
			},
			iPad() {
				return navigator.userAgent.match( /iPad/i ) || ( 'MacIntel' === navigator.platform && 1 < navigator.maxTouchPoints );
			},
			iPod() {
				return navigator.userAgent.match( /iPod/i );
			},
			iOS() {
				return ( isMobile.iPhone() || isMobile.iPad() || isMobile.iPod() );
			},
			Opera() {
				return navigator.userAgent.match( /Opera Mini/i );
			},
			Windows() {
				return navigator.userAgent.match( /IEMobile/i );
			},
			any() {
				return ( isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() );
			},
		};

		hrefArray = window.location.href.split( '?' );

		if ( 'openAR' === hrefArray[ 1 ] ) {
			openAR( hrefArray[ 2 ] );
		}
	} );
} );
